import React from "react";
import { useTranslation } from "react-i18next";

const PaymentFailedPage = () => {
  const { t } = useTranslation();
  return (
    <div className="max-w-4xl mx-auto p-6 bg-gray-100 rounded-lg shadow-md mt-10">
      {/* Failure Banner */}
      <div className="bg-red-500 text-white p-6 rounded-lg text-center mb-6">
        <h1 className="text-2xl font-bold">{t("studentDash.paymentFailed.title")}</h1>
        <p className="text-lg">
          {t("studentDash.paymentFailed.subtitle")}
        </p>
      </div>

      {/* Suggested Actions */}
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-xl font-semibold border-b-2 border-red-500 pb-2 mb-4">
          {t("studentDash.paymentFailed.whatCanYouDoNext")}
        </h2>
        <ul className="list-disc list-inside space-y-2 text-gray-700">
          <li>
            {t("studentDash.paymentFailed.tip1")}
          </li>
          <li>
            {t("studentDash.paymentFailed.tip2")}
          </li>
          <li>
            {t("studentDash.paymentFailed.tip3")}
          </li>
        </ul>
      </div>

      {/* Footer Note */}
      <div className="text-center text-gray-500 text-sm mt-6">
        {/* <p>
          Need help? Contact us at{" "}
          <a
            href="mailto:support@edolutions.com"
            className="text-red-500 underline"
          >
            support@edolutions.com
          </a>{" "}
          or try making the payment again.
        </p> */}
      </div>
    </div>
  );
};

export default PaymentFailedPage;
